import { useBranding } from "../../../contexts/branding";

export default function Header() {
    const { label, logoUrl } = useBranding();

    return (
        <div className="container">
            <div className="row">
                <div
                    className={`d-flex col-sm-12 col-md-12 margin-bottom-0 ${
                        label === "HabitNu" ? "" : "justify-content-center pt-4"
                    }`}
                >
                    <div className="">
                        <a href="/">
                            <img
                                src={logoUrl}
                                alt={label}
                                style={
                                    label === "HabitNu"
                                        ? {
                                              width: "150px",
                                          }
                                        : {
                                              width: "350px",
                                          }
                                }
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
